import { render, staticRenderFns } from "./PublicInformation.vue?vue&type=template&id=1115e2f8&scoped=true"
import script from "./PublicInformation.vue?vue&type=script&lang=js"
export * from "./PublicInformation.vue?vue&type=script&lang=js"
import style0 from "./PublicInformation.vue?vue&type=style&index=0&id=1115e2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1115e2f8",
  null
  
)

export default component.exports